module.exports = __webpack_public_path__ + "static/103_001-540d881e2f7f708ad2edde635d56367a.jpg";